const getTimeFromISOstring = (
    value,
    options = {
        hour: 'numeric', minute: 'numeric'
    }) => {
    return value ? Intl.DateTimeFormat('it-IT', options).format(new Date(value)) : value;
}

export default getTimeFromISOstring;